const CustomizeThemeHeader = `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export default CustomizeThemeHeader;
